import { DEFAULT_COUNTRY } from "./types";
import { PostAddress } from "../../api/commercial/generated-types";

export const defaultAddress: () => PostAddress = () => {
  return {
    street: "",
    streetNr: "",
    city: "",
    zipCode: "",
    country: { alpha2: DEFAULT_COUNTRY },
  };
};
